/* Bear Baby Boutique – prijsslider met twee grepen boven de prijsvelden van Dawn.
   Slepen werkt de velden "Van"/"Tot" bij (hele euro's); bij loslaten krijgt het veld een
   input-event zodat het filterformulier van Dawn verstuurt. Typen in de velden beweegt de grepen mee.
   Het element wordt bij elke filterwissel opnieuw gerenderd; connectedCallback bindt dan opnieuw. */
if (!customElements.get('bb-price-slider')) {
  class BBPriceSlider extends HTMLElement {
    connectedCallback() {
      this.min = Number(this.dataset.min) || 0;
      this.max = Math.max(Number(this.dataset.max) || 1, this.min + 1);
      this.rangeMin = this.querySelector('.bb-price-slider__input--min');
      this.rangeMax = this.querySelector('.bb-price-slider__input--max');
      const next = this.nextElementSibling;
      const container = next && next.matches('price-range') ? next : this.closest('price-range') || this.parentElement;
      const fields = container ? container.querySelectorAll('.field__input') : [];
      this.fieldMin = fields[0];
      this.fieldMax = fields[1];
      if (!this.rangeMin || !this.rangeMax || !this.fieldMin || !this.fieldMax) return;

      // Slepen: alleen de weergave en de velden bijwerken, het formulier nog niet versturen.
      this.addEventListener('input', (event) => {
        if (!event.target.matches('.bb-price-slider__input')) return;
        event.stopPropagation();
        this.clamp(event.target);
        this.paint();
        this.writeFields();
      });
      // Loslaten: Dawn's formulier laten versturen via een input-event op het tekstveld.
      this.addEventListener('change', (event) => {
        if (!event.target.matches('.bb-price-slider__input')) return;
        event.stopPropagation();
        const field = event.target === this.rangeMin ? this.fieldMin : this.fieldMax;
        field.dispatchEvent(new Event('input', { bubbles: true }));
      });
      // Typen in de velden: grepen volgen.
      [this.fieldMin, this.fieldMax].forEach((field) => {
        field.addEventListener('input', () => this.readFields());
      });
      this.readFields();
    }

    parse(value, fallback) {
      if (value === '' || value == null) return fallback;
      const n = Number(String(value).replace(/\./g, '').replace(',', '.'));
      return Number.isFinite(n) ? n : fallback;
    }

    clamp(changed) {
      let lo = Number(this.rangeMin.value);
      let hi = Number(this.rangeMax.value);
      if (lo > hi) {
        if (changed === this.rangeMin) hi = lo; else lo = hi;
        this.rangeMin.value = lo;
        this.rangeMax.value = hi;
      }
    }

    paint() {
      const lo = Number(this.rangeMin.value);
      const hi = Number(this.rangeMax.value);
      const span = this.max - this.min;
      this.style.setProperty('--bb-lo', `${((lo - this.min) / span) * 100}%`);
      this.style.setProperty('--bb-hi', `${((hi - this.min) / span) * 100}%`);
      this.rangeMin.setAttribute('aria-valuetext', `€${lo}`);
      this.rangeMax.setAttribute('aria-valuetext', `€${hi}`);
    }

    writeFields() {
      const lo = Number(this.rangeMin.value);
      const hi = Number(this.rangeMax.value);
      this.fieldMin.value = String(lo);
      this.fieldMax.value = hi >= this.max ? (this.fieldMax.dataset.max || String(hi)) : String(hi);
    }

    readFields() {
      const lo = Math.min(Math.max(this.parse(this.fieldMin.value, this.min), this.min), this.max);
      const hi = Math.min(Math.max(this.parse(this.fieldMax.value, this.max), this.min), this.max);
      this.rangeMin.value = Math.min(lo, hi);
      this.rangeMax.value = Math.max(lo, hi);
      this.paint();
    }
  }
  customElements.define('bb-price-slider', BBPriceSlider);
}

/* De prijsvelden staan standaard op de laagste en hoogste prijs. Die grenswaarden zijn geen
   filter: haal ze uit de querystring voordat Dawn het formulier verstuurt. */
(() => {
  if (typeof FacetFiltersForm === 'undefined' || FacetFiltersForm.prototype.bbPatched) return;
  FacetFiltersForm.prototype.bbPatched = true;
  const toNumber = (value) => {
    if (value === '' || value == null) return NaN;
    return Number(String(value).trim().replace(/\./g, '').replace(',', '.'));
  };
  FacetFiltersForm.prototype.createSearchParams = function (form) {
    const formData = new FormData(form);
    form.querySelectorAll('price-range .field__input').forEach((field) => {
      const value = toNumber(field.value);
      const isMin = /gte$/.test(field.name);
      const bound = toNumber(isMin ? field.dataset.min : field.dataset.max);
      if (Number.isNaN(value) || (!Number.isNaN(bound) && value === bound)) formData.delete(field.name);
    });
    return new URLSearchParams(formData).toString();
  };
})();
